export const STUDY_ID_REGEX = /Study.[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/g;
export const STUDY_VERSION_URL_REGEX =
    /studydetails\/Study.[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}\/version/gi;
export const ECONSENT_REGEX = /^\/econsentbuilder\/Study/;

export const MISSING_ITEM_LABEL = 'Undefined';
export const PENDING_MIGRATION_ITEM_LABEL = MISSING_ITEM_LABEL;

export const defaultCountLimit = 200;

export const maxCoreDataPointsPerActivity = 250;

export const DEFAULT_LANGUAGE = 'en-US';

// Date and time shown for signatures, e.g. "07 Sep 2021, 10:48am EST".
export const SIGNATURE_DATE_FORMAT = 'DD MMM YYYY, h:mma z';

export const minutesInDay = 60 * 24;
export const minutesInHour = 60;
